import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import FeaturedGrid from "@/pages/home/components/FeaturedGrid";
import CollectionSection from "@/pages/home/components/CollectionSection";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  return (
    <div className="w-full">
      <h1 className="sr-only">星辰影视 - 最新电影电视剧资源大全</h1>
      <HeroCarousel />
      <CategoryEntry />
      <FeaturedGrid />
      <CollectionSection />
      <SiteIntro />
    </div>
  );
}